import { render, staticRenderFns } from "./MusicPreview.vue?vue&type=template&id=3fcadedf&scoped=true&"
import script from "./MusicPreview.vue?vue&type=script&lang=js&"
export * from "./MusicPreview.vue?vue&type=script&lang=js&"
import style0 from "./MusicPreview.vue?vue&type=style&index=0&id=3fcadedf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcadedf",
  null
  
)

export default component.exports